export const BLOCK = "block";
export const BLOCK_STATE = "state";
export const PAGE = "page";
export const THEME = "theme";
export const GALLERY = "gallery";
export const GRAPHIC = "graphic";
export const HTML = "html";
export const ICON = "icon";
export const IFRAME = "iframe";
export const LINE = "line";
export const SIMPLE = "simple";
export const SOCIAL = "social";
export const SVG = "svg";
export const TEXT = "text";
export const VIDEO = "video";
export const LOTTIE = "lottie";
export const GROUP = "group";
export const BUTTON = "button";
/** @type {"input"} */
export const FORM_INPUT = "input";
/** @type {"select"} */
export const FORM_SELECT = "select";
/** @type {"radio"} */
export const FORM_RADIO = "radio";
/** @type {"checkbox"} */
export const FORM_CHECKBOX = "checkbox";
/**
 * A form field's element type, which is also its merge-utils type.
 * @typedef {typeof FORM_INPUT | typeof FORM_SELECT | typeof FORM_RADIO | typeof FORM_CHECKBOX} FormFieldType
 */

export default {
  BLOCK,
  BLOCK_STATE,
  PAGE,
  THEME,
  GALLERY,
  GRAPHIC,
  HTML,
  ICON,
  IFRAME,
  LINE,
  SIMPLE,
  SOCIAL,
  TEXT,
  VIDEO,
  LOTTIE,
  GROUP,
  BUTTON,
  FORM_INPUT,
  FORM_SELECT,
  FORM_RADIO,
  FORM_CHECKBOX,
};
